// extracted by mini-css-extract-plugin
export default {"newProject_container":"NewProject_newProject_container__f3LQs","projects_grid":"NewProject_projects_grid__Gj1O1"};